import type { BonusProduct } from "./types"

const POLL_INTERVAL_MS = 100
const MAX_WAIT_MS = 10000

const isBusy = (item: BonusProduct | undefined) =>
  Boolean(
    item &&
      (item.isPriceLoading ||
        item.isChangePeriodLoading ||
        item.isAddToBasketLoading)
  )

/**
 * Resolves once the item has no request in flight (or after `MAX_WAIT_MS`, so
 * a stuck flag can't hold the caller forever). A parameter sync that runs
 * while a resource update is still writing its result to the store would
 * read stale resource quantities and PATCH them to the basket.
 */
export function waitForBonusItemIdle(
  getItem: () => BonusProduct | undefined
): Promise<void> {
  return new Promise((resolve) => {
    const startedAt = Date.now()

    const check = () => {
      if (!isBusy(getItem()) || Date.now() - startedAt >= MAX_WAIT_MS) {
        resolve()
        return
      }

      setTimeout(check, POLL_INTERVAL_MS)
    }

    check()
  })
}
